export const CREATE_AFFILIATE = "CREATE_AFFILIATE";
export const FETCH_AFFILIATES = "FETCH_AFFILIATES";
export const FETCH_AFFILIATE_STATS = "FETCH_AFFILIATE_STATS";
export const FETCH_AFFILIATE_PAYMENTS = "FETCH_AFFILIATE_PAYMENTS";
